import { takeCompletionReturn } from "../../utils/profileCompletionReturn";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./CompletionPage.css";
import { ArrowLeft } from "lucide-react";
import socialPawsLogo from "../../assets/socialPawsLogo.svg";
import MobileTopBar from "../../components/MobileTopBar";
import DesktopTopBar from "../../components/DesktopTopBar";

const HalfCompletedPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();

  // Retrieve the current user's profile from Redux
  const profile = useSelector((state) => state.user.profile);

  const handleGoBack = () => {
    const returnState = takeCompletionReturn(profile?.id);
    navigate(returnState ? "/profile-details" : "/dashboard-switcher", {
      replace: true,
      state: returnState,
    });
  };

  // Sync Redux profile data into the local formData state on mount
  useEffect(() => {
    if (profile) {
      const primaryDog =
        profile.dogs && profile.dogs.length > 0 ? profile.dogs[0] : null;

      setFormData((prev) => {
        let mappedPersonality = prev.dogPersonality;
        if (
          !mappedPersonality &&
          primaryDog?.personality &&
          Array.isArray(primaryDog.personality)
        ) {
          mappedPersonality = {};
          primaryDog.personality.forEach((p, idx) => {
            mappedPersonality[idx + 1] = p;
          });
        }

        return {
          ...prev,
          name: prev.name || profile.user_name || "",
          email: prev.email || profile.user_email || "",
          phone: prev.phone || profile.user_phone || "",
          street: prev.street || profile.user_address || "",
          city: prev.city || profile.user_city || "",
          state: prev.state || profile.user_state || "",
          zip: prev.zip || profile.user_zipcode || "",
          apartment: prev.apartment || profile.user_address_line_2 || "",
          userBio: prev.userBio || profile.user_bio || "",
          team:
            prev.team || (profile.user_dog_status === 1 ? "paws" : "social"),
          selectedBringsYouHere: prev.selectedBringsYouHere?.length
            ? prev.selectedBringsYouHere
            : profile.whats_brings_you || [],

          dogName: prev.dogName || primaryDog?.dog_name || "",
          dogGender: prev.dogGender || primaryDog?.dog_gender || "",
          dogBreed: prev.dogBreed || primaryDog?.dog_breed || "",
          dogBirthDate: prev.dogBirthDate || primaryDog?.dog_birthday || "",
          dogActivity:
            prev.dogActivity || primaryDog?.dog_activity?.toLowerCase() || "",
          dogBio: prev.dogBio || primaryDog?.bio || "",
          dogAgeGroup: prev.dogAgeGroup || primaryDog?.age_group || "",
          availability: prev.availability?.length
            ? prev.availability
            : primaryDog?.availability || [],
          selectedTraits: prev.selectedTraits?.length
            ? prev.selectedTraits
            : primaryDog?.dog_traits || [],
          selectedHobbies: prev.selectedHobbies?.length
            ? prev.selectedHobbies
            : primaryDog?.dog_hobbies || [],

          // Format specific object schemas
          socialExperienceLevelWithDogs:
            prev.socialExperienceLevelWithDogs ||
            (primaryDog?.along_with_other_dogs
              ? { label: primaryDog.along_with_other_dogs }
              : null),
          socialExperienceWithHumans:
            prev.socialExperienceWithHumans ||
            (primaryDog?.along_with_other_humans
              ? { label: primaryDog.along_with_other_humans }
              : null),
          dogPersonality: mappedPersonality || prev.dogPersonality || {},
        };
      });
    }
  }, [profile, setFormData]);

  const handleContinueOnboarding = () => {
    console.log("taps_continue_onboarding", formData);

    setFormData((prev) => ({
      ...prev,
      dogPersonalityOrigin: "half-completed",
      onboardingMode: "update",
    }));

    // Route based on team selection or existing user dog status
    if (formData.team === "social" || profile?.user_dog_status === 0) {
      navigate("/team-social-checklist", { state: { step: 1 } });
    } else {
      navigate("/dog-personality", {
        state: {
          step: 2,
          fromHalfCompleted: true,
        },
      });
    }
  };

  return (
    <div className="completion-container">
      <MobileTopBar
        onBack={handleGoBack}
        backColor="#000"
        logoColor="#009fd9"
        blueLogo="true"
        isProtectedRoute={false}
      />
      <DesktopTopBar
        showBack={true}
        onBack={handleGoBack}
        backColor="#000"
        showProgress={false}
      />

      {/* Main Content */}
      <div className="completion-content">
        <h1 className="completion-title">
          COMPLETE YOUR PROFILE TO START CONNECTING
        </h1>
        <h1 className="completion-title" style={{ color: "#727272" }}>
          Help keep the pack friendly, trusted and welcoming
        </h1>
        <div className="completion-buttons" style={{ gap: "1rem" }}>
          <button
            className="completion-button button-gap"
            onClick={handleContinueOnboarding}
          >
            COMPLETE YOUR PROFILE
          </button>
          <button
            className="completion-button"
            onClick={handleGoBack}
          >
            GO BACK
          </button>
        </div>
      </div>
    </div>
  );
};

export default HalfCompletedPage;
